var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"vx-spinner"},[(_vm.spinnerVisible)?_c('div',{staticClass:"spinner-container",class:{ fullscreen: _vm.fullScreen }},[_c('img',{staticClass:"spinner",attrs:{"alt":"Loading","src":_vm.image,"title":"Loading"}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-348a6260","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/common/vx-spinner/vx-spinner.html
// module id = null
// module chunks = 